<template>
  <div class="watch-and-see" id="watch">
    <div class="watch-and-see__top">
      <h2 v-html="content.title"></h2>
      <div class="watch-and-see__navigation">
        <div class="watch-and-see__navigation-prev">
          <svg width="104" height="76" viewBox="0 0 104 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M103.004 38L3.0039 38" stroke="#BA8748" stroke-width="3"/>
            <path d="M39 2.00024L3 38.0002L39 74.0002" stroke="#BA8748" stroke-width="3"/>
          </svg>
        </div>
        <div class="watch-and-see__navigation-next">
          <svg width="103" height="76" viewBox="0 0 103 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.00390625 38L100.004 38" stroke="#BA8748" stroke-width="3"/>
            <path d="M64.0078 2.00024L100.008 38.0002L64.0078 74.0002" stroke="#BA8748" stroke-width="3"/>
          </svg>
        </div>
      </div>
      <p v-html="content.subtitle"></p>
    </div>
    <div class="watch-and-see__slider">
      <div v-swiper:mySwiper="swiperOption">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide watch-and-see__slide"
            v-for="(item, index) in content.slides"
            :key="index"
          >
            <div class="watch-and-see__slide-top" @click="onClickVideo(index,item)">
              <transition-group name="fade" mode="out-in">
                <template>
                  <div :key="`gradient-${index}`" class="gradient"/>
                  <h3 :class="{'faded': activeSlides.findIndex(i => i === index) === -1}" :key="`title-${index}`" v-html="item.title"></h3>
                  <div :key="`border-${index}`" class="border-box" v-if="activeSlides.findIndex(i => i === index) !== -1"/>
                  <img
                      :class="{'faded': activeSlides.findIndex(i => i === index) === -1}"
                      :key="`poster-${index}`"
                      :src="windowWidth > 600 ? item.youtube.poster : item.youtube.mobile"
                      :alt="item.title">
                  <svg :class="{'faded': activeSlides.findIndex(i => i === index) === -1}" :key="`play-${index}`" width="124" height="124"
                       viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="62" cy="62" r="61" stroke="white" stroke-width="2"/>
                    <path d="M80 62.5L53 79L53 46L80 62.5Z" fill="white"/>
                  </svg>
                </template>
              </transition-group>
            </div>
            <div
              class="watch-and-see__slide-bottom"
              :class="{'watch-and-see__slide-bottom--hidden': index === activePlayerIndex || activeSlides.findIndex(i => i === index) === -1}"
            >
              <div class="border-box"></div>
              <p v-html="item.subtitle"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {bus} from "../../utils/bus";

export default {
  name: "WatchAndSee",

  props: {
    content: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      activeSlide: 0,
      secondSlide:0,
      activePlayerIndex: -1,

      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: '.watch-and-see__navigation-next',
          prevEl: '.watch-and-see__navigation-prev',
        },
        breakpoints: {
          601: {
            spaceBetween: 32
          },
          801: {
            spaceBetween: 32
          }
        }
      }
    }
  },

  mounted () {
    this.mySwiper.on('transitionEnd', () => {
      this.activeSlide = this.mySwiper.activeIndex;
      // this.secondSlide = this.mySwiper.activeIndex + 1
      // console.log(this.activeSlide)
      this.onVideoStop()
    })
    this.mySwiper.on('reachEnd', () => {
      this.$nextTick(() => {
        setTimeout(() => {
          this.activeSlide = this.mySwiper.slides.length - 1
          this.onVideoStop()
        }, 350)
      })
    })
  },

  methods: {
    onClickVideo (index,item) {
      // this.activePlayerIndex = index;
         bus.$emit('open-video', item.youtube.youtubeId)
    },

    onVideoStop () {
      this.$nextTick(() => {
        this.activePlayerIndex = -1
      })
    }
  },
  computed: {
    windowWidth() {
      return window.innerWidth
    },

    activeSlides () {
      if (window.innerWidth > 1300)
        return [this.activeSlide - 1, this.activeSlide, this.activeSlide + 1, this.activeSlide + 2]
      return [this.activeSlide]
    }
  }
}
</script>

<style lang="scss">
@import './watch-and-see';
</style>
